// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { QuestionCircleOutlined } from '@ant-design/icons';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// icons
const icons = { QuestionCircleOutlined };

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const help: NavItemType = {
  id: 'help',
  title: <FormattedMessage id="help" />,
  type: 'group',
  url: '/support/help',
  icon: icons.QuestionCircleOutlined
};

export default help;
